// Lista deployow (static_deploys) z rozwijanym build_log — wyciagniete z dawnego DeployStepCard.
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import type { DeployHistoryRow } from "@/services/staticSite/migrationRunner";

export function DeployHistoryList({ history }: { history: DeployHistoryRow[] }) {
  if (!history.length) return <p className="text-sm text-muted-foreground">Brak deployów.</p>;
  return (
    <ul className="divide-y rounded-md border text-xs">
      {history.map((h) => (
        <li key={h.id} className="flex flex-wrap items-center gap-2 px-2 py-1.5">
          {h.status === "success" ? <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" /> : h.status === "failed" ? <XCircle className="h-3.5 w-3.5 text-red-500" /> : <Loader2 className="h-3.5 w-3.5 animate-spin" />}
          <span>{new Date(h.started_at).toLocaleString("pl-PL")}</span>
          <Badge variant="outline" className="text-[10px]">{h.trigger}</Badge>
          {h.branch !== "main" && <Badge variant="secondary" className="text-[10px]">{h.branch}</Badge>}
          {h.file_count != null && <span className="text-muted-foreground">{h.file_count} plików · wgrano {h.uploaded_count ?? 0}</span>}
          {h.cf_url && <a href={h.cf_url} target="_blank" rel="noreferrer" className="ml-auto underline">{h.cf_url.replace(/^https?:\/\//, "")}</a>}
          {h.error && <span className="w-full text-destructive">{h.error}</span>}
          {h.build_log && (
            <details className="w-full">
              <summary className="cursor-pointer text-muted-foreground">Log builda (Astro) · {h.build_log.split("\n").length} linii</summary>
              <pre className="mt-1 max-h-64 overflow-auto rounded bg-muted/50 p-2 font-mono text-[10px] leading-tight whitespace-pre-wrap">{h.build_log}</pre>
            </details>
          )}
        </li>
      ))}
    </ul>
  );
}
